/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const ConnectLarkPage = lazyLoad(
  () => import('./index'),
  module => module.ConnectLarkPage
);
